import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Old bookmark for the removed agency Google Business page. Each salon now connects its own Google
 * account in Settings › Integrations, so send the agency team home instead of a 404.
 */
export const Route = createFileRoute('/_auth/agency/google-business/')({
  beforeLoad: () => {
    throw redirect({ to: '/agency', replace: true });
  },
});
